import MasterShopFaceRegistrationPageV1 from './MasterShopFaceRegistrationPageV1';

export default MasterShopFaceRegistrationPageV1;
